import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'lib-form-amount-input',
  templateUrl: './form-amount-input.component.html',
  styleUrls: ['./form-amount-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormAmountInputComponent {
  @Input() control: FormControl<number | null>;
  @Input() label?: string;
  @Input() placeholder = '0.00';
}
